import axios from 'axios';

import config from '../utils/config';

import * as AuthActions from '../actions/auth';
import * as PassActions from '../actions/password';
import * as ActivityActions from '../actions/activity';
import * as CommentsActions from '../actions/comments';
import * as CommunicationActions from '../actions/communication';
import * as DatepickerActions from '../actions/datepickers';
import * as FindUserActions from '../actions/findUser';
import * as PaymentsActions from '../actions/paymentsInfo';
import * as UserExplorerActions from '../actions/userExplorer';
import * as LoginActions from '../actions/login';
import * as Interceptors from '../interceptors';
import interceptorResponse from '../interceptors/axiosInterceptorResponse/interceptor';
import * as FindUserCreators from './findUser';

import ReduxAction from '../interfaces/ReduxAction';
import { AnyAction } from 'redux';

const URL = config().login;

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

export const fetchAuthAction = (login: string, password: string): ReduxAction => {
  return (dispatch): void => {
    dispatch(AuthActions.fetchAuthLoading());
    const params = new URLSearchParams();

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    params.append('password', password);
    params.append('username', login);
    axios.post(URL, params, config)
      .then(response => {
        Interceptors.setToken(response.data.access);
        Interceptors.setRefreshToken(response.data.refresh);
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
        dispatch(AuthActions.fetchAuthSuccess(response.data.access));
        dispatch(AuthActions.fetchRefreshToken(response.data.refresh));
        dispatch(LoginActions.fetchLoginInit());
        dispatch(PassActions.fetchPasswordInit());
      })
      .catch(() => {
        dispatch(AuthActions.fetchAuthFail());
      });
  };
};

const URLRefresh = config().refresh;

export const fetchRefreshAuthToken = (func: () => AnyAction): ReduxAction => {
  return (dispatch): void => {
    dispatch(AuthActions.fetchAuthLoading());
    const params = new URLSearchParams();

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    params.append('refresh', localStorage.getItem('refreshToken'));
    axios.post(`${URLRefresh}`, params, config)
      .then(response => {

        localStorage.setItem('token', response.data.access);
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
        dispatch(AuthActions.fetchAuthSuccess(response.data.access));
        dispatch(func());
      })
      .catch(() => {
        dispatch(AuthActions.fetchAuthFail());
        dispatch(onLogout());
      });
  };
};

export const fetchRefreshAuth = (firstLoad: boolean): ReduxAction => {
  return (dispatch): void => {
    dispatch(AuthActions.fetchAuthLoading());
    const params = new URLSearchParams();

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    params.append('refresh', localStorage.getItem('refreshToken'));
    axios.post(`${URLRefresh}`, params, config)
      .then(response => {
        localStorage.setItem('token', response.data.access);
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
        dispatch(AuthActions.fetchAuthSuccess(response.data.access));
        if (firstLoad) {
          return null;
        }
        dispatch(FindUserCreators.findUser());
      })
      .catch(() => {
        dispatch(AuthActions.fetchAuthFail());
        dispatch(onLogout());
      });
  };
};

const profileURL = config().profile;

export const appMounted = (): ReduxAction => {
  return (dispatch, getState): void => {
    if (getState().auth.token) {
      dispatch(AuthActions.fetchAuthLoading());

      axios.get(`${profileURL}`)
        .then(response => {
          dispatch(AuthActions.fetchMountedAuthSuccess(response.data.user));
        })
        .catch(() => {});
    }
    return null;
  };
};

export const onLogout = (): ReduxAction => {
  return (dispatch): void => {
    dispatch(AuthActions.fetchAuthInit());
    dispatch(AuthActions.fetchExitButton());
    dispatch(PassActions.fetchPasswordInit());
    dispatch(ActivityActions.fetchActivityInit());
    dispatch(CommentsActions.fetchCommentsInit());
    dispatch(CommunicationActions.fetchCommunicationInit());
    dispatch(DatepickerActions.fetchDatepickersInitAction());
    dispatch(FindUserActions.fetchFindUserInitAction());
    dispatch(PaymentsActions.fetchPaymentsInit());
    dispatch(UserExplorerActions.fetchUserExplorerInitAction());
    localStorage.clear();
  };
};

interceptorResponse();
